import { useEffect, useRef } from "react";

const Video = ({ videoSrc, className }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
    }
  }, [videoSrc]);

  return (
    <video
      ref={videoRef}
      key={videoSrc}
      autoPlay
      loop
      muted
      playsInline
      preload="auto"
      width="100%"
      style={{ maxWidth: "100%", height: "100%", objectFit: "cover" }}
      className={className}
    >
      <source src={videoSrc} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
};

export default Video;
